import { useEffect, useState } from "react";

const RangeSection = ((props) => {

    const [selectedDate, setSelectedDate] = useState(new Date());

    const [mounted, setMounted] = useState(false);


    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [date, setDate] = useState('');

    useEffect(() => {
        setMonth(selectedDate.getMonth() + 1);
        setYear(selectedDate.getFullYear());
        setDate(selectedDate.getDate());
        setMounted(true);
    }, []);


    useEffect(() => {
        if (!mounted) return;
        setMonth(selectedDate.getMonth() + 1);
        setYear(selectedDate.getFullYear());
        setDate(selectedDate.getDate());
        props.change(selectedDate);

    }, [selectedDate]);


    const getPreviousData = ((date) => {
        const previous = new Date(date.getTime());
        previous.setDate(date.getDate() - 1);
        setSelectedDate(previous)
    });

    const getNextData = ((date) => {
        let today = new Date();
        if (date.toDateString() == today.toDateString()) return;
        const next = new Date(date.getTime());
        next.setDate(date.getDate() + 1);
        setSelectedDate(next)
    });

    return (
        <>
            <div className='range-section'>
                <div className='section-A'>
                    <div className="date-selection-wrapper">
                        <div className="date-selected">
                            <div className="prev">
                                <button onClick={() => getPreviousData(selectedDate)}>
                                    <img src={'icon/prev.png'} />
                                </button>
                            </div>
                            <div className="date">
                                <span>{year.toString().padStart(2, '0')}</span>
                                <span>.</span>
                                <span>{month.toString().padStart(2, '0')}</span>
                                <span>.</span>
                                <span>{date.toString().padStart(2, '0')} </span>
                            </div>
                            <div className="next">
                                <button onClick={() => getNextData(selectedDate)}>
                                    <img src={'icon/next.png'} />
                                </button>
                            </div>
                        </div>

                        <div className="main-calendar-wrapper">
                            <input type="date" value={selectedDate.toJSON().slice(0, 10)} onChange={(e) => {

                                let d = new Date(e.target.value);
                                setSelectedDate(d);
                            }} />
                            <button onClick={() => {
                                let d = new Date();
                                setSelectedDate(d);
                            }}>오늘</button>
                        </div>

                    </div>
                </div>
                <div className='section-B'>
                    <div>
                        <button onClick={() => {
                            let d = new Date();
                            setSelectedDate(d);
                        }} className="rotate-btn">
                            <img src={'icon/rotate-icon.svg'} />
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
});

export default RangeSection;